import React, { Component, PropTypes } from 'react';
import {Link} from 'react-router';
import '../styles/numPad.scss';
import RecommendationAlgorithm from '../models/RecommendationAlgorithm'
import Question from '../models/Question'
import Answer from '../models/Answer'
var ReactCSSTransitionGroup = require('react-addons-css-transition-group');

class NumPadDelegate {
  constructor() {

  }

  didEnterText(numPad, text) {

  }
  clearButtonTouched(numPad) {

  }
}

class NumPad extends Component {
  constructor() {
    super();
  }

  componentWillMount() {

  }

  delegate() : NumPadDelegate {
    return this.props.delegate;
  }

  handleClick(key, event) {
    if (this.delegate() != null) {
      if (key != "Clear") {
        this.delegate().didEnterText(this, key);
      }
      else {
        this.delegate().clearButtonTouched(this);
      }
    }
  }

  buttonWithValue(value, styleClass) {
    return (
      <div key={value} onClick={this.handleClick.bind(this, value)} className={styleClass}>{value}</div>
    );
  }

  render() {
    return (
      <div className="numPadContentContainer">
        <div className="numPadRow">
          {this.buttonWithValue("1", "numPadButton")}
          {this.buttonWithValue("2", "numPadButton")}
          {this.buttonWithValue("3", "numPadButton")}
        </div>
        <div className="numPadRow">
          {this.buttonWithValue("4", "numPadButton")}
          {this.buttonWithValue("5", "numPadButton")}
          {this.buttonWithValue("6", "numPadButton")}
        </div>
        <div className="numPadRow">
          {this.buttonWithValue("7", "numPadButton")}
          {this.buttonWithValue("8", "numPadButton")}
          {this.buttonWithValue("9", "numPadButton")}
        </div>
        <div className="numPadRow">
          {this.buttonWithValue(".", "numPadButton")}
          {this.buttonWithValue("0", "numPadButton")}
          {this.buttonWithValue("Clear", "numPadButton clear")}
        </div>
      </div>
    );
  }

}

export default NumPad;



/** WEBPACK FOOTER **
 ** ./src/components/NumPad.js
 **/